import { appActions, appSelectors } from '@appStore/reducers/app'
import store from '@appStore/store'
import isEmpty from 'lodash/isEmpty'

store.subscribe(() => {
	const state = store.getState()

	const appProfile = appSelectors.appProfile(state),
		appProfileDone = appSelectors.appProfileDone(state),
		auth = appSelectors.auth(state),
		isInstalled = appSelectors.isInstalled(state),
		isInstalledDone = appSelectors.isInstalledDone(state),
		linkedInfo = appSelectors.linkedProfile(state),
		linkedProfileDone = appSelectors.linkedProfileDone(state)

	if (!isInstalled && !appProfileDone && auth !== 'none') {
		store.dispatch(appActions.appAuth('none'))
	}

	if (isInstalledDone && linkedProfileDone && appProfileDone) {
		const isProfileReady = isInstalled && !isEmpty(appProfile)

		let nextStatus: 'auth' | 'none' = 'none'

		if (isProfileReady && linkedInfo !== null) {
			const { timezoneOffset, workingHoursSet } = appProfile

			if (timezoneOffset !== null && workingHoursSet) {
				nextStatus = 'auth'
			}
		}

		if (auth !== nextStatus) {
			store.dispatch(appActions.appAuth(nextStatus))
		}
	}
})
